<body>
  <!-- Nav is admin-only: shown only on /admin routes when server confirmed admin access. -->
  <div [class.survey-intake-view]="!isAdminRoute || !showAdminNav">
    @if (isAdminRoute && showAdminNav) {
      <app-nav-menu></app-nav-menu>
    }
    <div class="container survey-container">
      <main role="main">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</body>
